$(document).ready(function () {
    $('ul li.dropdown').hover(function() {
        $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(200);
      }, function() {
        $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(200);
      });
      $(function () {
        $('body').tooltip({
          selector: '[data-toggle="tooltip"]',
          trigger: 'hover'
        });
      })
})
